import { IAlbum } from "../../common/Album";

const album: IAlbum = {
  title: 'Covert Church',
  date: new Date(2023, 6, 2),
  img: '/img/cow.jpeg',
  tracks: [
    {
      title: 'Covert Cafe',
      src: '/songs/2023-07-02/covert_cafe.mp3',
    },
    {
      title: 'If you have to ask',
      src: '/songs/2023-07-02/if_you_have_to_ask.mp3',
    },
    {
      title: 'How Wow Brown Cow',
      src: '/songs/2023-07-02/how_wow_brown_cow.mp3',
    },
    {
      title: 'Summertime Express',
      src: '/songs/2023-07-02/summertime_express.mp3',
    },
    {
      title: 'All I wanna do is Play',
      src: '/songs/2023-07-02/all_i_want_to_do_is_play.mp3',
    },
    {
      title: 'Magnificent Story to Tell',
      src: '/songs/2023-07-02/magnificent_story_to_tell.mp3',
    },
    {
      title: 'Racoon Confab in Session',
      src: '/songs/2023-07-02/raccoon_confab_in_session.mp3',
    },
    {
      title: 'Hyperextension Mechanism Protocol',
      src: '/songs/2023-07-02/hyperextension_mechanism_protocol.mp3',
    },
    {
      title: 'Quantized Vibrational Occurrance',
      src: '/songs/2023-07-02/quantized_vibrational_occurrance.mp3',
    },
    {
      title: 'Unbridled Autodetermination Quotient',
      src: '/songs/2023-07-02/unbridled_autodetermination_quotient.mp3',
    },
    {
      title: 'Ectopasmic Recallibration Process',
      src: '/songs/2023-07-02/ectoplasmic_recalibration_process.mp3',
    },
    {
      title: 'Roger That: Origin Story',
      src: '/songs/2023-07-02/rodger_that_origin_story.mp3',
    },
    {
      title: 'Nocturnal Confessions',
      src: '/songs/2023-07-02/nocturnal_confessions.mp3',
    },
    {
      title: 'Ambien Dream-Walking',
      src: '/songs/2023-07-02/ambien_dream_walking.mp3',
    },
    {
      title: 'Making the Kessel Run in less than 12 Parsecs',
      src: '/songs/2023-07-02/making_the_kessel_run.mp3',
    },
  ]
}
export default album;